<template>
    <div class="body">
        <div class="detay">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    export default {
      data() {
        return {}
      },
      created() {
        if (this.$store.getters.Admin == '0') this.$router.push("/403");
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Kullanici/_route.vue